<template>
  <div v-if="applicant != null">      
    <div class="flex items-center">

      <div class="flex items-center mr-8">
        <div class="text-lg mr-4">{{ getApplicantName(applicant) }} </div>
        <NoteIcon page="applicants" />
      </div>

      <template v-if="applicant.person != null">
        <template v-if="applicant.person.isPrimary != 1">
          <a href="#" 
            class="text-sm no-underline text-blue-500 hover:underline"
            @click.prevent="setPrimaryApplicant()">Make this primary applicant</a>
        </template>

        <template v-else>
          <div class="text-green-600 flex items-center font-semibold">
            <svg width="18" height="18" stroke-width="2" class="mr-2" stroke="currentColor" fill="none">
              <use xlink:href="/static/img/feather-sprite.svg#check-circle"/>
            </svg>

            Primary applicant
          </div>
        </template>
      </template>
    </div>
    

    <div v-if="applicant.person != null" class="mt-8 border-b border-gray-300">
      <router-link 
        :to="{ 
          name  : 'application-applicant-profile',
          params: {
            clientId   : $route.params.clientId,
            applicantId: applicant.id
          }
        }" 
        tag="a"
        class="tab-link">Profile</router-link>

      <router-link 
        :to="{ 
          name  : 'application-applicant-address',
          params: {
            clientId   : $route.params.clientId,
            applicantId: applicant.id
          }
        }" 
        tag="a"
        class="tab-link ml-8">Address</router-link>

      <router-link 
        :to="{ 
          name  : 'application-applicant-employment',
          params: {
            clientId   : $route.params.clientId,
            applicantId: applicant.id
          }
        }" 
        tag="a"
        class="tab-link ml-8">Employment</router-link>
    </div>

    <router-view />
  </div>
</template>

<script>
  import NoteIcon   from '@/shared/components/NoteIcon'

  export default {

    components: {
      NoteIcon
    },

    computed : {
      applicant() {
        for(let i=0; i < this.$store.state[this.$store.state.view + 'Module'].client.applicants.length; i++) {
          if(this.$store.state[this.$store.state.view + 'Module'].client.applicants[i].id == this.$route.params.applicantId) {
            return this.$store.state[this.$store.state.view + 'Module'].client.applicants[i]
          }
        }
      }
    },

    methods : {
      setPrimaryApplicant() {
        this.showLoader("Processing...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.applicant.id              
        }, 'applicant/set-primary-applicant', () => {
          this.hideLoader()
          location.reload()              
        })
      },
    },

    metaInfo () {
      return {
        title: this.getClientPrimaryApplicant != null ? this.getApplicantName(this.getClientPrimaryApplicant) : "Brokerpad"
      }
    }
  }
</script>